module.exports = __webpack_public_path__ + "static/skill-factory-1-30c51a914ddeed4273586d7071b39ac5.svg";